export default "/assets/images/la-strong-bg-sm.jpg?05d06e4b35df238dcfb878a96e9d5eaf";